import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { API_URL } from '../../../api/api';
import { Icon } from '@iconify/react';
import { Link, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';

const API_TodayCashLoanCollection = `${API_URL}/todaycashcollection`;

const TodayCashCollectionLayer = () => {
    const token = localStorage.getItem('token');
    const location = useLocation();
    const [cashGroups, setCashGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [groupName, setGroupName] = useState('');

    const queryParams = new URLSearchParams(location.search);
    const branch = queryParams.get('branch');
    const group = queryParams.get('group');
    const type = queryParams.get('type');

    useEffect(() => {
        const fetchCashGroups = async () => {
            try {
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                const response = await axios.get(API_TodayCashLoanCollection, {
                    params: { branch, group, type }
                });
                const groups = response.data.members || [];
                setCashGroups(groups);
                if (groups.length > 0) {
                    setGroupName(groups[0]?.group || '');
                }
            } catch (error) {
                console.error('Error fetching cash collections:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchCashGroups();
    }, [branch, group, type, token]);

    if (loading) {
        return <p>Loading cash collections...</p>;
    }

    const handleApproveAll = async () => {
        const today = new Date().toLocaleDateString('en-CA', {
            timeZone: 'Asia/Kolkata'
        }); // Outputs in format: YYYY-MM-DD

        try {
            const res = await axios.post(`${API_URL}/approveCashPaymentsForDate`, {
                date: today
            });

            Swal.fire("Success", res.data.message, "success");
        } catch (error) {
            console.error("Approve error:", error);
            Swal.fire("Error", "Failed to approve payments", "error");
        }
    };

    const totalEmi = cashGroups.reduce((sum, loan) => sum + Number(loan.emi || 0), 0);
    const totalPaidToday = cashGroups.reduce((sum, loan) => sum + Number(loan.today_paid || 0), 0);
    const remaining = totalEmi - totalPaidToday;


    return (
        <div className="row gy-4">
            <div className="col-md-12">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                    <div className="mb-3 d-flex gap-4">
                            <div><strong>Today EMI:</strong> ₹{totalEmi.toFixed(2)}</div>
                            <div><strong>Today Paid:</strong> ₹{totalPaidToday.toFixed(2)}</div>
                            <div><strong>Remaining:</strong> ₹{remaining.toFixed(2)}</div>
                        </div>
                        <h5 className="card-title mb-0">Today Cash Collection - {groupName}</h5>
                    </div>
                    <div className="card-body">

                        <div className="d-flex justify-content-end mb-3">
                            <button className="btn btn-success" onClick={handleApproveAll}>
                                ✅ Approve All (Today)
                            </button>
                        </div>

                        <div className="table-responsive scroll-sm">
                            <table className="table bordered-table text-sm">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Member</th>
                                        <th>Father/Husband</th>
                                        <th>EMI</th>
                                        <th>Paid</th>
                                        <th>Total Paid</th>
                                        <th>Balance</th>
                                        <th>Cash Amt</th>
                                        <th>Staff</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cashGroups.map((loan, index) => (
                                        <tr key={loan.loan_id}>
                                            <td>{index + 1}</td>
                                            <td>{loan.member_name}</td>
                                            <td>{loan.father || 'N/A'}</td>
                                            <td>{loan.emi || '0.00'}</td>

                                            {/* Placeholder - update when backend adds these fields */}
                                            <td>{loan.today_paid || '0.00'}</td>
                                            <td>{loan.total_paid || '0.00'}</td>
                                            <td>{loan.balance || '0.00'}</td>
                                            <td>{loan.loan_amount_with_interest || '0.00'}</td>

                                            <td>{loan.staff || 'N/A'}</td>
                                            <td>{loan.status}</td>
                                            <td>
                                                <Link to={`/cash-loan-payment/${loan.loan_id}`} title="Pay EMI">
                                                    <Icon icon="material-symbols:currency-rupee" className="text-success text-xl cursor-pointer" />
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TodayCashCollectionLayer;
